export const SET_VIEW_TYPE = "SET_VIEW_TYPE";
export const SET_VIEW_TYPE = "SET_VIEW_TYPE";
